import React from 'react';
import { connect } from 'react-redux';
import { AppHeader, TabPanel, SelectCompanyBox } from 'components';

import AccommodationsList from './components/accommodations-list/AccommodationsList';
import ActivitiesList from './components/activities-list/ActivitiesList';

import useStyles, { TabsRoot } from './styles';
import ToolBar from './components/ToolBar';
import { EntityTabs } from '../../constants/entity-tabs';
import EntityTabBar from './components/EntityTabBar';
import useOverview from './hooks/useOverview';
import useEntityTabs from './hooks/useEntityTabs';

const AccommodationsAndActivities = ({ businessOwner }) => {
  const classes = useStyles();

  const isOwnerSelected = Boolean(businessOwner.selectedBusinessOwner.id);

  const businessOwnerId =
    businessOwner.selectedBusinessOwner.ownerId ||
    businessOwner.selectedBusinessOwner.id;

  const { overview, refetch } = useOverview(businessOwnerId);
  const { tab, handleChangeTab, Tabs } = useEntityTabs({ overview, refetch });

  return (
    <div className={classes.root}>
      <AppHeader />

      {isOwnerSelected && (
        <>
          <ToolBar tab={tab} />

          <TabsRoot>
            <EntityTabBar tab={tab} onChangeTab={handleChangeTab} tabs={Tabs} />

            <TabPanel
              className={classes.tabContentWrapper}
              value={tab}
              index={EntityTabs.Accommodation}
            >
              <AccommodationsList
                ownerId={businessOwnerId}
                deleteCallback={refetch}
              />
            </TabPanel>

            <TabPanel
              className={classes.tabContentWrapper}
              value={tab}
              index={EntityTabs.Activities}
            >
              <ActivitiesList
                ownerId={businessOwnerId}
                deleteCallback={refetch}
              />
            </TabPanel>
          </TabsRoot>
        </>
      )}

      {!isOwnerSelected && <SelectCompanyBox />}
    </div>
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(AccommodationsAndActivities);
